"use strict";
exports.__esModule = true;
exports.PAYMENT_SCHEDULE = void 0;
exports.PAYMENT_SCHEDULE = {
    FIRST_PAYMENT: {
        SPLIT_MEMBERSHIP: 'When you’re ready',
        SIMPLIFIED_PAYMENTS: 'When you pay rent',
        REGULAR_PAYMENTS: 'When rent is due'
    },
    MEMBERSHIP_FEE: {
        TITLE: 'Membership fee',
        DESCRIPTION: '15th of the month'
    }
};
